import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
  {
    question: 'What is Bidder iQ?',
    answer: 'Bidder iQ is a collector-car pricing intelligence tool built for serious buyers, sellers, and enthusiasts. Pro takes it to another level allowing you to estimate prices, see market trends, and save your favorite models, all with an ad-free experience. Plus, a Chrome extension that overlays live market data directly on auction listings.'
  },
  {
    question: 'What does the Chrome Extension do?',
    answer: 'Once installed, the extension activates on supported listings and displays key analytics—12-month units, sell-through rate, average, auction low, auction high, and past auctions—directly on the page. No extra tabs, no spreadsheets.'
  },
  {
    question: 'Which auction platforms does the Chrome Extension support?',
    answer: 'The Bidder iQ Chrome Extension currently works with: Bring a Trailer, PCARMARKET, and Cars & Bids. Additional platforms may be added based on user demand.'
  },
  {
    question: 'Does Bidder iQ work on iOS devices?',
    answer: 'iOS does not support Chrome Extensions, so the Bidder iQ Extension will not work. The web platform does work on iOS, but there are a few features that do not translate.'
  },
  {
    question: 'Do I need an account to use Bidder iQ?',
    answer: 'Yes. All Bidder iQ features—both in the extension and in the Web App—require a paid account. We use Clerk for secure sign-in.'
  },
  {
    question: 'What happens if I cancel?',
    answer: 'Your subscription remains active through the current billing cycle. After that, your access ends. We do not delete your data or account history. To cancel, go to your subscription section in the Dashboard or simply email david@bidderiq.com.'
  },
  {
    question: 'Will the Bidder iQ Chrome Extension slow down my browser?',
    answer: 'Not at all. The extension is lightweight and only runs on supported pages. All calculations happen locally after a quick data fetch.'
  },
  {
    question: 'Which browsers are supported?',
    answer: 'The web app works on any browser. The Chrome Extension works on Google Chrome (desktop).'
  },
  {
    question: 'What personal data do you collect?',
    answer: 'Just your email address, stored securely by Clerk. We do not track your browsing activity outside supported auction sites.'
  },
  {
    question: 'How are payments handled?',
    answer: 'All transactions are processed by Stripe. Bidder iQ never sees or stores your payment details.'
  }
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="faq-section" id="faqs">
      <div className="faq-label">FAQ</div>
      <h2 className="faq-title">Need Help? Find<br/>Your Answers Here</h2>
      <div className="faq-list">
        {faqData.map((item, idx) => (
          <div key={idx} className={`faq-item${openIndex === idx ? ' open' : ''}`}>
            <button className="faq-question" onClick={() => toggleFAQ(idx)} aria-expanded={openIndex === idx}>
              <span>{item.question}</span>
              <span className="faq-icon">{openIndex === idx ? '−' : '+'}</span>
            </button>
            <div className="faq-answer-wrapper" style={{maxHeight: openIndex === idx ? '200px' : '0'}}>
              <div className="faq-answer">{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
